import type {ChangeEvent} from 'react';

export interface VariantOverrideOption {
  idAiPrompt: number;
  alias: string | null;
  isActive: boolean;
  weightPct: number;
}

export interface AgentOverrideRow {
  agentType: string;
  currentAlias: string | null;
  options: VariantOverrideOption[];
}

/** The select value that means "no override" — must stay in sync with the backend's `NO_OVERRIDE` sentinel, which is what tells the server to clear rather than set the override. */
export const NO_OVERRIDE_VALUE = 'auto' as const;

export type ForcedImageProvider = typeof NO_OVERRIDE_VALUE | 'gemini-3.1-flash-image-preview' | 'openai-gpt-image' | 'seedream';

export type ForcedTextRemovalMethod =
  | typeof NO_OVERRIDE_VALUE
  | 'nanoBanana'
  | 'gptImage2'
  | 'wanImageEdit'
  | 'briaErase'
  | 'flux2Klein9b'
  | 'seedream5Pro'
  | 'jasper';

export type MockCredits = typeof NO_OVERRIDE_VALUE | '0' | '1' | '2' | '5' | '20' | '100';

export interface OverrideSelectOption<TValue extends string = string> {
  value: TValue;
  label: string;
}

export type ForcedProviderOption = OverrideSelectOption<ForcedImageProvider>;

export type ForcedTextRemovalMethodOption = OverrideSelectOption<ForcedTextRemovalMethod>;

export type MockCreditsOption = OverrideSelectOption<MockCredits>;

export interface OverrideSelectHandlerOptions<TValue extends string> {
  isValidValue: (value: string) => value is TValue;
  save: (value: TValue) => Promise<void>;
  onSaved: (value: TValue) => void;
  onError: () => void;
}

export interface OverrideSelectRowProps {
  id: string;
  label: string;
  value: string;
  options: OverrideSelectOption[];
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
}
